import Vue from 'vue'
import VueResource from 'vue-resource'
import Parse from 'parse'

Vue.use(VueResource)

const baseUrl = 'https://api.tasklaw.com.br/parse/'
// const baseUrl = 'http://localhost:6789/parse/'

Parse.initialize('6939e808daa0c434d3d0a68825a529ba', '0e60ad33a2b549cab413f83b97713d6c')
Parse.serverURL = baseUrl

Vue.http.interceptors.push(request => function (response) {
    if ((response.data.code) && response.data.code === 209) {
        if (response.url.substring(baseUrl.length) !== 'logout') {
            window.getApp.invalidSession = true
        }
    }
})

Vue.http.interceptor.before = function (request) {
    if (Vue.http.previousRequest && Vue.http.previousRequest.url === request.url && Vue.http.previousRequest.params === request.params) {
        Vue.http.previousRequest.abort()
    }
    Vue.http.previousRequest = request
}

class API {
    constructor (endpoint, params) {
        this.endpoint = endpoint
        this.params = params

        Vue.http.headers.common['X-Parse-Application-Id'] = '6939e808daa0c434d3d0a68825a529ba'
        Vue.http.headers.common['X-Parse-REST-API-Key'] = '0e60ad33a2b549cab413f83b97713d6c'

        const sessionToken = localStorage.getItem('sessionToken') ?? undefined
        const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))?.client?.objectId ?? undefined
        if (sessionToken !== undefined) Vue.http.headers.common['X-Parse-Session-Token'] = sessionToken
        if (currentUserCompany !== undefined) Vue.http.headers.common['x-parse-current-company'] = currentUserCompany
    }

    get getBaseUrl () {
        return baseUrl
    }

    get path () {
        switch (this.endpoint) {
        // User
        case API.EndPoints.login:
            return 'login'
        case API.EndPoints.logout:
            return 'logout'
        case API.EndPoints.requestPasswordReset:
            return 'requestPasswordReset'
        case API.EndPoints.me:
            return 'users/me'
        case API.EndPoints.getUsers:
            return 'users'
        case API.EndPoints.getUser:
            return 'users/' + this.endpoint.id
        case API.EndPoints.addUser:
            return 'users/'
        case API.EndPoints.editUser:
            return 'users/' + this.endpoint.id
        case API.EndPoints.deleteUser:
            return 'users/' + this.endpoint.id

        // Club
        case API.EndPoints.getClubs:
            return 'classes/Club/?count=true&include=client'
        case API.EndPoints.getClub:
            return 'classes/Club/' + this.endpoint.id + '?include=client'
        case API.EndPoints.addClub:
            return 'functions/addClub'
        case API.EndPoints.editClub:
            return 'classes/Club/' + this.endpoint.id
        case API.EndPoints.deleteClub:
            return 'classes/Club/' + this.endpoint.id
        case API.EndPoints.upload:
            return 'files/' + this.endpoint.filename
        case API.EndPoints.deleteFile:
            return 'functions/deleteFile'

        // Activity
        case API.EndPoints.getInteractions:
            return 'functions/getActivities'
        case API.EndPoints.addInteraction:
            return 'classes/Interaction'
        case API.EndPoints.deleteInteraction:
            return 'classes/Interaction/' + this.endpoint.id
        case API.EndPoints.createInteraction:
            return 'functions/createInteraction'
        case API.EndPoints.removeDemandFile:
            return 'functions/removeDemandFile'

        // Clients
        case API.EndPoints.getClient:
            return 'functions/getClient'
        case API.EndPoints.getAllClient:
            return 'functions/getAllClient'
        case API.EndPoints.getAllClientIds:
            return 'functions/getAllClientIds'
        case API.EndPoints.createClient:
            return 'functions/createClient'
        case API.EndPoints.updateClient:
            return 'functions/updateClient'
        case API.EndPoints.removeClient:
            return 'functions/removeClient'
        case API.EndPoints.newPassword:
            return 'functions/newPassword'
        case API.EndPoints.getUsersClient:
            return 'functions/getUsersClient'
        case API.EndPoints.createUserClient:
            return 'functions/createUserClient'
        case API.EndPoints.getUserClient:
            return 'functions/getUserClient'
        case API.EndPoints.updateUserClient:
            return 'functions/updateUserClient'
        case API.EndPoints.removeUserClient:
            return 'functions/removeUserClient'
        case API.EndPoints.saveCompanyInfo:
            return 'functions/saveCompanyInfo'
        case API.EndPoints.createCompany:
            return 'functions/createCompany'

        // Notification
        case API.EndPoints.getNotification:
            return 'functions/getNotification'
        case API.EndPoints.setNotification:
            return 'functions/setNotification'
        case API.EndPoints.getNewNotifications:
            return 'functions/getNewNotifications'
        case API.EndPoints.exemplegetNewNotifications:
            return 'Notification'
        case API.EndPoints.logPreview:
            return 'functions/logPreview'

        // Demands
        case API.EndPoints.getAllDemand:
            return 'functions/getAllDemand'
        case API.EndPoints.getDemand:
            return 'functions/getDemand'
        case API.EndPoints.createDemand:
            return 'functions/createDemand'
        case API.EndPoints.updateDemand:
            return 'functions/updateDemand'
        case API.EndPoints.getDemandsByisDone:
            return 'functions/getDemandsByisDone'
        case API.EndPoints.createTask:
            return 'classes/DemandTask'
        case API.EndPoints.editTask:
            return 'classes/DemandTask/' + this.endpoint.id
        case API.EndPoints.deleteTask:
            return 'classes/DemandTask/' + this.endpoint.id
        case API.EndPoints.getTask:
            return 'functions/getTask'
        case API.EndPoints.reorderTask:
            return 'functions/reorderTask'

        // Contracts
        case API.EndPoints.getAllContract:
            return 'functions/getAllContract'
        case API.EndPoints.getContract:
            return 'functions/getContract'
        case API.EndPoints.saveContract:
            return 'functions/saveContract'
        case API.EndPoints.getAllContractPart:
            return 'functions/getAllContractPart'
        case API.EndPoints.deleteContract:
            return 'classes/Contract/' + this.endpoint.id
        case API.EndPoints.sendContractGPTMessage:
            return 'functions/sendContractGPTMessage'
        case API.EndPoints.createContractGPTChat:
            return 'functions/createContractGPTChat'
        case API.EndPoints.getContractRoles:
            return 'functions/getContractRoles'

        // Captable
        case API.EndPoints.getClientCorporateInfo:
            return 'functions/getClient'
        case API.EndPoints.getCorporateCaptable:
            return 'classes/CorporateCaptable'
        case API.EndPoints.getCorporateBoardMembers:
            return 'classes/CorporateBoardMembers'
        case API.EndPoints.getCorporateHistoric:
            return 'classes/CorporateHistoric'
        case API.EndPoints.captableRegister:
            return 'functions/captableRegister'
        case API.EndPoints.deleteCaptable:
            return 'functions/deleteCaptable'
        case API.EndPoints.administrationRegister:
            return 'functions/administrationRegister'
        case API.EndPoints.deleteAdministration:
            return 'functions/deleteAdministration'
        case API.EndPoints.removeAct:
            return 'functions/removeAct'
        case API.EndPoints.saveAct:
            return 'functions/saveAct'

        // FilePreview
        case API.EndPoints.dowloadFile:
            return this.endpoint.url

        // DemandWorkedHour
        case API.EndPoints.getDemandWorkedHour:
            return 'classes/DemandWorkedHour'
        case API.EndPoints.saveDemandWorkedHour:
            return 'classes/DemandWorkedHour'
        case API.EndPoints.deleteDemandWorkedHour:
            return 'classes/DemandWorkedHour/' + this.endpoint.id

        // CorporateBrand
        case API.EndPoints.getCorporateBrands:
            return 'classes/CorporateBrand'
        case API.EndPoints.getCorporateBrand:
            return 'classes/CorporateBrand/' + this.endpoint.id
        case API.EndPoints.saveCorporateBrand:
            return 'classes/CorporateBrand'
        case API.EndPoints.editCorporateBrand:
            return 'classes/CorporateBrand/' + this.endpoint.id
        case API.EndPoints.deleteCorporateBrand:
            return 'classes/CorporateBrand/' + this.endpoint.id
        case API.EndPoints.getCorporateBrandLogging:
            return 'classes/CorporateBrandLogging'

        // UserCompany
        case API.EndPoints.getUserCompany:
            return 'classes/UserCompany'
        case API.EndPoints.getUserCompanyDetail:
            return 'classes/UserCompany/' + this.endpoint.id
        case API.EndPoints.addUserCompany:
            return 'classes/UserCompany'
        case API.EndPoints.editUserCompany:
            return 'classes/UserCompany/' + this.endpoint.id
        case API.EndPoints.deleteUserCompany:
            return 'classes/UserCompany/' + this.endpoint.id
        case API.EndPoints.batch:
            return 'batch'

        // Brand
        case API.EndPoints.getBrandINPI:
            return 'getBrand'

        // ManagerCompany
        case API.EndPoints.getManagerCompany:
            return 'classes/ManagerCompany'
        case API.EndPoints.getManagerCompanyDetail:
            return 'classes/ManagerCompany/' + this.endpoint.id
        case API.EndPoints.addManagerCompany:
            return 'classes/ManagerCompany'
        case API.EndPoints.editManagerCompany:
            return 'classes/ManagerCompany/' + this.endpoint.id
        case API.EndPoints.deleteManagerCompany:
            return 'classes/ManagerCompany/' + this.endpoint.id

        default:
            return ''
        }
    }

    get url () {
        return this.getBaseUrl + this.path
    }

    get method () {
        if (
            this.endpoint === API.EndPoints.me ||
            this.endpoint === API.EndPoints.getClub ||
            this.endpoint === API.EndPoints.getClubs ||
            this.endpoint === API.EndPoints.getCorporateCaptable ||
            this.endpoint === API.EndPoints.getCorporateBoardMembers ||
            this.endpoint === API.EndPoints.getCorporateHistoric ||
            this.endpoint === API.EndPoints.dowloadFile ||
            this.endpoint === API.EndPoints.getDemandWorkedHour ||
            this.endpoint === API.EndPoints.getCorporateBrands ||
            this.endpoint === API.EndPoints.getCorporateBrand ||
            this.endpoint === API.EndPoints.getCorporateBrandLogging ||
            this.endpoint === API.EndPoints.getUserCompany ||
            this.endpoint === API.EndPoints.getUserCompanyDetail ||
            this.endpoint === API.EndPoints.getManagerCompany ||
            this.endpoint === API.EndPoints.getManagerCompanyDetail ||
            this.endpoint === API.EndPoints.getUsers ||
            this.endpoint === API.EndPoints.getUser
        ) {
            return Vue.http.get(this.url, { params: this.params })
        } else if (
            (this.endpoint === API.EndPoints.editClub) ||
            (this.endpoint === API.EndPoints.editTask) ||
            (this.endpoint === API.EndPoints.editUser) ||
            (this.endpoint === API.EndPoints.editUserCompany) ||
            (this.endpoint === API.EndPoints.editManagerCompany) ||
            (this.endpoint === API.EndPoints.editCorporateBrand)
        ) {
            return Vue.http.put(this.url, this.params)
        } else if (
            this.endpoint === API.EndPoints.deleteClub ||
            this.endpoint === API.EndPoints.deleteInteraction ||
            this.endpoint === API.EndPoints.deleteTask ||
            this.endpoint === API.EndPoints.deleteDemandWorkedHour ||
            this.endpoint === API.EndPoints.deleteUserCompany ||
            this.endpoint === API.EndPoints.deleteManagerCompany ||
            this.endpoint === API.EndPoints.deleteUser ||
            this.endpoint === API.EndPoints.deleteCorporateBrand ||
            this.endpoint === API.EndPoints.deleteContract
        ) {
            return Vue.http.delete(this.url, this.params)
        } else if (
            this.endpoint === API.EndPoints.upload
        ) {
            return Vue.http.post(this.url, this.params, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
        }

        return Vue.http.post(this.url, this.params)
    }

    static params = {}

    static EndPoints = {
        // users
        'login': {},
        'logout': {},
        'requestPasswordReset': {},
        'me': {},
        'getUsers': {},
        'getUser': {
            id: null
        },
        'addUser': {},
        'editUser': {
            id: null
        },
        'deleteUser': {
            id: null
        },

        // club
        'getClubs': {},
        'getClub': {
            id: null
        },
        'addClub': {},
        'editClub': {
            id: null
        },
        'deleteClub': {
            id: null
        },
        'upload': {
            filename: null
        },
        'deleteFile': {},
        // activity
        'getActivities': {},
        'addInteraction': {},
        'getDemandsByisDone': {},
        'deleteInteraction': {
            id: null
        },
        'createInteraction': {},
        'removeDemandFile': {},
        // clients
        'getClient': {},
        'getAllClient': {},
        'getAllClientIds': {},
        'createClient': {},
        'updateClient': {},
        'removeClient': {},
        'newPassword': {},
        'getUsersClient': {},
        'createUserClient': {},
        'getUserClient': {},
        'updateUserClient': {},
        'removeUserClient': {},
        'saveCompanyInfo': {},
        'createCompany': {},

        // Notification
        'getNotification': {},
        'setNotification': {},
        'logPreview': {},
        'getNewNotifications': {},

        // demands
        'getAllDemand': {},
        'getDemand': {},
        'createDemand': {},
        'updateDemand': {},
        'createTask': {},
        'editTask': {},
        'deleteTask': {},
        'getTask': {},
        'reorderTask': {},

        // contracts
        'getAllContract': {},
        'getContract': {},
        'saveContract': {},
        'deleteContract': {
            id: null
        },
        'getAllContractPart': {},
        'sendContractGPTMessage': {},
        'createContractGPTChat': {},
        'getContractRoles': {},

        // captable
        'getClientCorporateInfo': {},
        'getCorporateCaptable': {},
        'getCorporateBoardMembers': {},
        'getCorporateHistoric': {},
        'captableRegister': {},
        'deleteCaptable': {},
        'administrationRegister': {},
        'deleteAdministration': {},
        'saveAct': {},
        'removeAct': {},

        // FilePreview
        'dowloadFile': {
            url: null
        },

        // DemandWorkedHour
        'getDemandWorkedHour': {},
        'saveDemandWorkedHour': {},
        'deleteDemandWorkedHour': {
            id: null
        },

        // CorporateBrand
        'getCorporateBrands': {},
        'getCorporateBrand': {
            id: null
        },
        'saveCorporateBrand': {},
        'editCorporateBrand': {},
        'deleteCorporateBrand': {
            id: null
        },
        'getCorporateBrandLogging': {},

        // UserCompany
        'getUserCompany': {},
        'getUserCompanyDetail': {
            id: null
        },
        'addUserCompany': {},
        'editUserCompany': {
            id: null
        },
        'deleteUserCompany': {
            id: null
        },
        // ManagerCompany
        'getManagerCompany': {},
        'getManagerCompanyDetail': {
            id: null
        },
        'addManagerCompany': {},
        'editManagerCompany': {
            id: null
        },
        'deleteManagerCompany': {
            id: null
        },
        'batch': {},

        // Brand
        'getBrandINPI': {}
    }

    async request () {
        return this.method
    }
}

export default API
